/** @jsx jsx */

import { memo } from 'react';
import { css, jsx } from '@emotion/react';
import Button from '@atlaskit/button/standard-button';
import __noop from '@atlaskit/ds-lib/noop';
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { fontSize, gridSize } from '@atlaskit/theme/constants';
const height = gridSize() * 3 / fontSize();
const noop = __noop;
const itemWrapperStyles = css({
  display: 'flex',
  boxSizing: 'border-box',
  maxWidth: '100%',
  height: `${height}em`,
  margin: "var(--ds-space-0, 0px)",
  padding: "var(--ds-space-0, 0px)",
  flexDirection: 'row',
  lineHeight: `${height}em`,
  '&:not(:last-child)::after': {
    width: "var(--ds-space-100, 8px)",
    padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-100, 8px)"}`,
    flexShrink: 0,
    content: '"/"',
    textAlign: 'center'
  }
});
const EllipsisItem = /*#__PURE__*/memo(props => {
  const {
    onClick = noop,
    testId,
    label
  } = props;
  return jsx("li", {
    css: itemWrapperStyles
  }, jsx(Button, {
    appearance: "subtle-link",
    spacing: "none",
    testId: testId,
    onClick: onClick,
    "aria-label": label
  }, "\u2026"));
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default EllipsisItem;